module.exports = __webpack_public_path__ + "img/bg-page-whitelabel.a9507e46.png";